module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_15-713fb979e15099a73501fe3c9c009049.jpg";